const TV = `${process.env.INTERNAL_IMAGES_URL}/images/png/tv-gazin.png`
const Consorcio = `${process.env.INTERNAL_IMAGES_URL}/images/png/consorcio.png`
const Seguros = `${process.env.INTERNAL_IMAGES_URL}/images/png/seguros.png`
const GazinBank = `${process.env.INTERNAL_IMAGES_URL}/images/png/gazin-bank.png`

import Image from 'next/image'
import { Box } from '@gazin/ecommerce-ui'
import { SectionTitle } from '../sectionTitle'
import {
  ConsorcioIcon,
  GazinBankIcon,
  TvGazinIcon,
  SegurosIcon,
} from '../icons'
import * as S from './styles'
import { useBlackFriday } from '../../contexto/hooks/useBlackFriday'

export type ItemServicoProps = {
  imagem: string
  nome: string
  descricao: string
  url: string
  icon: JSX.Element
}

export type SetorServicosProps = {
  darkTheme: boolean
}

const ItemServico = ({
  imagem,
  nome,
  descricao,
  url,
  icon,
}: ItemServicoProps) => {
  const { isBlackFridayTheme } = useBlackFriday()

  return (
    <S.ServicesLink href={url} target="_blank" rel="noopener noreferrer">
      <S.ServicesImage>
        <Image src={imagem} alt={nome} fill sizes="25rem" />
      </S.ServicesImage>
      <S.ServicesInfo darkTheme={isBlackFridayTheme}>
        <Box mt={{ base: 0, md: '0.1875rem' }}>{icon}</Box>
        <S.ServicesSubText>
          <h3>{nome}</h3>
          <p>{descricao}</p>
        </S.ServicesSubText>
      </S.ServicesInfo>
    </S.ServicesLink>
  )
}

export default function SetorServicos({ darkTheme }: SetorServicosProps) {
  return (
    <S.ServicesSection darkTheme={darkTheme}>
      <SectionTitle
        title="Gazin tem muito mais"
        subtitle="Nós queremos estar com você em todos os momentos especiais da sua vida. Conheça nossos outros serviços"
        darkTheme={darkTheme}
      />
      <S.ServicesReponsive>
        <S.ServicesContainer>
          <ItemServico
            imagem={Consorcio}
            nome="Consórcios"
            descricao="Com planejamento seus grandes sonhos se tornam realidade."
            url="https://consorciogazin.com.br/"
            icon={<ConsorcioIcon w={['4rem', '3.25rem']} />}
          />
          <ItemServico
            imagem={Seguros}
            nome="Seguros"
            descricao="Para proteger você e sua família em todos os momentos da vida."
            url="https://www.gazinseguros.com.br/"
            icon={<SegurosIcon w={['4rem', '3.25rem']} />}
          />
          <ItemServico
            imagem={GazinBank}
            nome="Gazin Bank"
            descricao="A escolha mais segura para cuidar da sua vida financeira."
            url="https://www.gazinbank.com.br/"
            icon={<GazinBankIcon w={['4rem', '3.25rem']} />}
          />
          <ItemServico
            imagem={TV}
            nome="TV Gazin"
            descricao="Uma emissora dedicada a levar entretenimento para você no conforto de sua casa."
            url="https://tvgazin.com.br/"
            icon={<TvGazinIcon w={['4rem', '3.25rem']} />}
          />
        </S.ServicesContainer>
      </S.ServicesReponsive>
    </S.ServicesSection>
  )
}
